import { userColumns } from "../config/column";
import { getUsers, getStatIds } from "../api/respons";
import { useEffect, useState } from "react";
import TableCustom from "./TableCustom";


const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getUsers();
        if (data.users && data.users.length > 0) {
          setUsers(data.users);
        }
      } catch (error) {
        console.error("Ошибка при получении серверов:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleClickStat = async () => {
      try {
        const data = await getStatIds();
      } catch (error) {
        console.error("Ошибка при получении серверов:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };


  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (error) {
    return <div>Произошла ошибка: {error.message}</div>;
  }

  return (
    <div className="container mx-auto p-4 te">
      <h1 className="text-center py-5 text-3xl">Список пользователей <button onClick={handleClickStat}>Скачать Telegram IDs</button></h1>
      <TableCustom items={users} columns={userColumns} />
    </div>
  );
};

export default Users;
